export var VERSION = '2.30.0';
//# sourceMappingURL=version.js.map